import React from 'react';
import PropTypes from 'prop-types';
import { SKILL_DISPLAY_NAMES, MEASURE_SCORE_DISPLAY_NAMES } from '../../../constants/assessments';
import { localize } from '../../../common/localization';
import { getMeasureScoreBySkillName } from '../../../common/utils/measureScoreBySkillName';

const PMMeasuresDropdownItem = ({ skillName, measureName, label }) => (
    <div className='dashboard-dropdown-item'>
        <div className='dashboard-dropdown-skill-name'>{localize(SKILL_DISPLAY_NAMES[skillName])}</div>
        <div className='dashboard-dropdown-measure-name'>
            {localize(
                MEASURE_SCORE_DISPLAY_NAMES[getMeasureScoreBySkillName(skillName, measureName)],
            )}
        </div>
        {label && <div className='dashboard-dropdown-label'>{localize(label)}</div>}
    </div>
);

PMMeasuresDropdownItem.propTypes = {
    skillName: PropTypes.string.isRequired,
    measureName: PropTypes.string.isRequired,
    label: PropTypes.string,
};

PMMeasuresDropdownItem.defaultProps = {
    label: '',
};

export default PMMeasuresDropdownItem;
